<template>
  <modal id="featured-proj-modal" :size="`lg`" :show-footer="false">
    <template v-slot:title> Featured Project - {{ projName }} </template>
    <template v-slot:body>
      <div class="row">
        <div class="col-md-12">
          <h4>
            <strong>Project Description: </strong>
          </h4>

          <div :class="[!showMoreContent ? descClass : '']" v-html="projDesc"></div>
          <template v-if="isOverflowing">
            <div class="row text-center pr-20">
              <a @click="toggleReadMore" class="read-more-style">
                Read {{ showMoreContent ? 'less' : 'more' }}
              </a>
            </div>
          </template>
          <div class="row mt-20">
            <template v-if="projectInfo.hasPlayLink">
              <div :class="[colClass]">
                <div class="panel panel-default feature-card">
                  <div class="panel-heading text-center">
                    <h5><strong>Play as a Participant</strong></h5>
                  </div>
                  <div class="panel-body mt-10">
                    <div class="row">
                      <div class="col-md-12 text-center">
                        <figure>
                          <img
                            src="/capsiminbox/images/Image_Play.svg"
                            width="240"
                            height="150"
                            alt="play as a participant image"
                          />
                          <figcaption>
                            Experience what the user goes through in this demo.
                          </figcaption>
                        </figure>
                        <button class="btn btn-primary mt-20" @click="handleDemoLink">
                          <i class="fas fa-external-link-square"></i>
                          <span class="btn-style pl-5">Play Demo</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="projectInfo.hasYoutubeUrl">
              <div :class="[colClass]">
                <div class="panel panel-default feature-card">
                  <div class="panel-heading text-center">
                    <h5 data-testid="watch-video-header"><strong>Watch Video</strong></h5>
                  </div>
                  <div class="panel-body mt-10 custom-vid-card-margin">
                    <div class="row">
                      <div class="col-md-12 text-center">
                        <figure>
                          <iframe
                            width="240"
                            height="150"
                            :src="youtubeEmbedLink"
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                          ></iframe>
                          <figcaption class="embed-video-desc">
                            Check out the video to learn how it was constructed.
                          </figcaption>
                        </figure>
                        <div class="mt-25 mb-5">
                          <div class="row btn-style-vid">
                            <span>
                              <img
                                src="/capsiminbox/images/youtube-brands-v2.svg"
                                class="youtube-icon"
                                alt="Youtube icon"
                                width="20"
                                height="20"
                            /></span>
                            <a :href="youtubeLink" class="video-link-style pl-5" target="_blank">
                              <strong>Watch Video</strong>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="projectInfo.hasDownloadProject">
              <div :class="[colClass]">
                <div class="panel panel-default feature-card">
                  <div class="panel-heading text-center">
                    <h5><strong>Download Project</strong></h5>
                  </div>
                  <div class="panel-body mt-10">
                    <div class="row">
                      <div class="col-md-12 text-center">
                        <figure>
                          <img
                            src="/capsiminbox/images/Image_Download.svg"
                            width="240"
                            height="150"
                            alt="play as a participant image"
                          />
                          <figcaption>
                            Save this project and immediately customize how you see fit.
                          </figcaption>
                        </figure>
                        <button class="btn btn-success mt-20" @click="handleCopyAndEdit">
                          <i class="fas fa-arrow-down"></i>
                          <span class="btn-style pl-5">Save and Edit</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer> </template>
  </modal>
</template>
<script>
  import { getDemoLink } from '@authoringPlatform/../api/versions';
  import { mapActions, mapGetters } from 'vuex';
  export default {
    name: 'FeaturedModal',
    props: {
      versionKey: {
        type: Number,
        required: true,
        default: 0,
      },
      projName: {
        type: String,
        required: true,
        default: '',
      },
      projDesc: {
        type: String,
        required: true,
        default: '',
      },
      youtubeLink: {
        type: String,
        required: false,
        default: '',
      },
      youtubeEmbed: {
        type: String,
        required: false,
        default: '',
      },
      projectInfo: {
        type: Object,
        required: true,
        default: {},
      },
      featureCardCount: {
        type: Number,
        required: true,
        default: 0,
      },
    },
    data() {
      return {
        youtubeEmbedLink: '',
        showMoreContent: false,
      };
    },

    mounted() {
      // stop modal video when modal is closed
      $('#featured-proj-modal').on('hidden.bs.modal', function () {
        $('#featured-proj-modal iframe').attr('src', $('#featured-proj-modal iframe').attr('src'));
      });
    },

    watch: {
      versionKey: {
        immediate: true,
        handler(oldKey, newKey) {
          if (oldKey !== newKey) {
            this.showMoreContent = false;
            this.youtubeEmbedLink = this.youtubeEmbed;
          }
        },
      },
    },
    methods: {
      ...mapActions('versions', ['duplicateVersion']),
      async handleDemoLink() {
        const { demoLink } = await getDemoLink(this.versionKey);
        const demoLinkUrl = 'http://' + demoLink;
        window.open(demoLinkUrl, '_blank');
      },
      toggleReadMore() {
        return (this.showMoreContent = !this.showMoreContent);
      },

      async handleCopyAndEdit() {
        await this.duplicateVersion({ versionKey: this.versionKey });
        this.$router.push({ name: 'skills', params: { resourceKey: this.duplicatedVersionKey } });
      },
    },
    computed: {
      ...mapGetters('versions', ['duplicatedVersionKey']),
      isOverflowing() {
        return this.projDesc.split(' ').length > 90;
      },
      isHtmlDesc() {
        const isHtml = RegExp.prototype.test.bind(/(<([^>]+)>)/i);

        return isHtml(this.projDesc);
      },
      colClass() {
        if (this.featureCardCount === 1) {
          return `col-md-12`;
        } else if (this.featureCardCount === 2) {
          return `col-md-6`;
        }
        return `col-md-4`;
      },
      descClass() {
        if (this.isHtmlDesc) {
          return 'html-desc';
        } else {
          return 'normal-desc';
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .read-more-style {
    font-size: 14px;
  }
  .read-more-style:hover {
    cursor: pointer;
  }
  .custom-vid-card-margin {
    margin-bottom: 3px;
  }
  .youtube-icon {
    margin-top: -3px;
  }
  .html-desc {
    max-height: 135px;
    overflow: hidden;
    padding-bottom: 20px;
  }
  .normal-desc {
    max-height: 145px;
    overflow: hidden;
    padding-bottom: 20px;
  }

  .video-link-style {
    margin-top: 10px;
  }
  .btn-style,
  .fa-arrow-down,
  .fa-external-link-square {
    font-size: 12px;
  }
  figcaption {
    font-size: 12px;
    padding-top: 5px;
  }
  .btn-style-vid {
    font-size: 14px;
  }

  .embed-video-desc {
    padding-top: 0px;
  }
  .feature-card {
    background: white;
  }
</style>
